var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M18.125 3.75H12.5A3.13 3.13 0 0 0 10 5a3.13 3.13 0 0 0-2.5-1.25H1.875a.625.625 0 0 0-.625.625v11.25a.625.625 0 0 0 .625.625H7.5a1.875 1.875 0 0 1 1.875 1.875.625.625 0 1 0 1.25 0A1.875 1.875 0 0 1 12.5 16.25h5.625a.624.624 0 0 0 .625-.625V4.375a.625.625 0 0 0-.625-.625M7.5 15h-5V5h5a1.875 1.875 0 0 1 1.875 1.875v8.75A3.1 3.1 0 0 0 7.5 15m10 0h-5a3.1 3.1 0 0 0-1.875.625v-8.75A1.875 1.875 0 0 1 12.5 5h5z"
  })));
};
export default SvgBookOpen;